import { useEffect, useState } from "react";
import ReviewStarBar from "./ReviewStarBar";
import { handleSubmit } from "../apis/dataService";
import { useAccount } from "../assets/js/ContextProviders/AccountContext";

function ReviewStars({ onStarChange }) {
    const [selectedStars, setSelectedStars] = useState(0);
    const {GetUsername} = useAccount();

    function handleStarClick(starNo) {
        setSelectedStars(starNo);
        onStarChange(starNo);
        const reviewsStars = document.querySelector('.ReviewStars')
        setTimeout(()=>{

            if(reviewsStars){
                reviewsStars.style.opacity = '0'
                setTimeout(()=>{
                    reviewsStars.style.height = '0px'
                },[300])
            }else{
                console.error('Something went wrong with the class "ReviewStars"')
            }
        },[500])
    }

    function ReviewStar(starNo) {
        return (
            <div
                key={starNo}
                className={`ReviewStars-star ${selectedStars >= starNo ? "review-colourful-star" : ""}`}
                id={`ReviewStars-stars-${starNo}star`}
                onClick={() => handleStarClick(starNo)}
            >
                <i className="fas fa-star"></i>
            </div>
        );
    }

    return (
        <div className="ReviewStars">
            <div className="ReviewStars-heading">
                Rate Us Out Of 5:
            </div>
            <div className="ReviewStars-stars">
                {[1, 2, 3, 4, 5].map((starNo) => ReviewStar(starNo))}
            </div>
            <div className="ReviewStars-messagecon"></div>
        </div>
    );
}

export default ReviewStars;
